import api from './api'

// get
export const getAllCountries = () => api.get(`utils/countries`)

export const getCities = (country, searchCity, pageNo) =>
  api.get(`utils/cities?country=${country}&filter=${searchCity}&page=${pageNo}&limit=10`)
